<div id="preloader_spinner" [class]="size ? ('size-'+ size) :''">
    <div class="preloader_spinner_icon" [ngClass]="size ? 'w-100 h-100':''"></div>
</div>